export const MONTHS_PER_YEAR = 12;
export const DAYS_PER_YEAR = 365;
export const SECONDS_PER_DAY = 60 * 60 * 24;
export const SECONDS_PER_YEAR = DAYS_PER_YEAR * SECONDS_PER_DAY;

export const ONE_HOUR_MS = 60 * 60 * 1000;
export const ONE_DAY_MS = ONE_HOUR_MS * 24;
export const ONE_YEAR_MS = SECONDS_PER_YEAR * 1000;
